module.exports = __webpack_public_path__ + "static/media/Styerian.dd3973c3.jpg";